export default __webpack_public_path__ + "static/media/Udemy-Make-website-on-Wordpress.ec7c895d.webp";